import { ReactNode } from 'react';
import { PostHogProvider as ReactPostHogProvider } from 'posthog-js/react';
import {
  getPostHogApiKey,
  getPostHogConfig,
  isPostHogEnabled,
} from '../config/posthog-config';

interface PostHogProviderProps {
  children: ReactNode;
}

/**
 * PostHog Analytics Provider
 * Wraps application with the official PostHogProvider from posthog-js/react
 */
export function PostHogProvider({ children }: PostHogProviderProps) {
  if (!isPostHogEnabled()) {
    if (import.meta.env.DEV) {
      console.warn('[PostHog] API key not found. Analytics disabled.');
    }
    return <>{children}</>;
  }

  const apiKey = getPostHogApiKey()!;
  const options = getPostHogConfig();

  return (
    <ReactPostHogProvider apiKey={apiKey} options={options}>
      {children}
    </ReactPostHogProvider>
  );
}
